var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dropdown",class:{ bounceIn: _vm.$parent.show }},[_c('transition',{attrs:{"name":"slide-fade"}},[_c('div',{ref:"dropdown",class:{ 'is-touch': _vm.isTouchDevice }},[_vm._t("default")],2)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }